import React, { useEffect, useRef, useState } from 'react'
import '../Styles/Article.css';
import {Link, useParams} from 'react-router-dom';
import Repository from '../Repository/Repository';
import Accordian from '../Utilities/Accordian/Accordian';
import { fetchArticle } from '../Functions';
import parse from "html-react-parser";
import {getAnalytics, logEvent} from "firebase/analytics";
import { Helmet } from 'react-helmet';

function Article() {
    const analytics = getAnalytics();
    const initialized = useRef(false);
    const params = useParams();
    const articleID = params.articleUID
    const [article, setArticle] = useState(null);

    useEffect(() => {
        console.log("Params", params)
        fetchArticle(params.id, setArticle);
    }, [params]);

    useEffect(() => {
        if (article && !initialized.current) {
            initialized.current = true;
            logEvent(analytics, 'Article Read', { name: `${article.title}`})
        }
    }, [article]);

    // Clean ReactQuill HTML output
    const cleanBody = (html) => {
        if (!html) return '';
        return html
            .replace(/<p><br><\/p>/g, '')
            .replace(/<p>\s*<\/p>/g, '')
            .replace(/<p>&nbsp;<\/p>/g, '')
            .replace(/(<\/p>)\s*(<p>)/g, '$1$2');
    };

    // Wrap sentences in spans for hover highlighting
    const wrapSentences = (html) => {
        if (!html) return '';
        
        // Process the HTML by wrapping sentences inside paragraph tags
        return html.replace(/<p>(.*?)<\/p>/g, (match, content) => {
            // Skip empty paragraphs
            if (!content.trim()) return match;
            
            // Split by sentence endings (. ! ?) followed by a space or end
            // This regex keeps the punctuation with the sentence
            const sentences = content.split(/(?<=[.!?])\s+/);
            
            const wrappedSentences = sentences
                .map(sentence => sentence.trim())
                .filter(sentence => sentence.length > 0)
                .map(sentence => `<span class="sentence">${sentence}</span>`)
                .join(' ');
            
            return `<p>${wrappedSentences}</p>`;
        });
    };

    if (!article) {
        return <div className='Article-loading'>Loading...</div>;
    }

    return (
        <div className='Article-container'>
            <Helmet>
                <title>{article.title}</title>
                <meta name='description' content={article.seoDescription}/>
                <meta name='keywords' content={article.seoKeywords} data-react-helmet="true"/>  
                <link rel='canonical' href={`/article/${article.articleUID}`}/>
                <meta property="og:url" content={`https://www.thetrehan.com/article/${article.articleUID}`}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content={article.title}/>
                <meta property="og:description" content={article.seoDescription}/>
                <meta property="og:image" itemProp="image" content={`${article.featureImageURL}`}/>
                <meta name="twitter:card" content={`${article.featureImageURL}`}/>
                <meta property="twitter:domain" content="thetrehan.com"/>
                <meta property="twitter:url" content={`https://www.thetrehan.com/article/${article.articleUID}`}/>
                <meta name="twitter:title" content={article.title}/>
                <meta name="twitter:description" content={article.seoDescription}/>
                <meta name="twitter:image" content={`${article.featureImageURL}`}/>
            </Helmet>
            <div className='Article-Accordian'><Accordian/></div>
            <div className="Article-page">
                <h1 className='Article-title'>{article.title ? article.title : "No Article Found"}</h1>
                <p className='Article-meta'>{article.author}</p>
                <p className='Article-meta'>{article.publishedDate.toDate().toLocaleDateString()}</p>
                <p className='Article-meta'>{article.date}</p>
                <img className='Article-featureImage' src={article.featureImageURL}/>
                <div className='Article-body'>
                    {parse(wrapSentences(cleanBody(article.body)))}
                </div>
            </div>
        </div>
    )
}

export default Article